/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { useAuthUser, useSignOut } from 'react-auth-kit'
import { useIntl } from 'react-intl'
import { Languages } from './Languages'
import { API } from 'src/feature/bite/domain'
import { Modal } from 'react-bootstrap'
import { useFirstLogin } from 'src/feature/auth/context/useMutation'

const HeaderUserMenu: FC = () => {
  const intl = useIntl()
  const userAuthData = useAuthUser()
  const signOut = useSignOut()

  const [firstLogin, setFirstLogin] = useState(false)
  const [firstLoginLoading, setFirstLoginLoading] = useState(false)

  const { mutateAsync: firstLoginMutation } = useFirstLogin()

  const logoutRequest = async () => {
    try {
      await fetch(`${API}/Auth/LogOut`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Authorization: 'Bearer ' + userAuthData().token,
        },
        credentials: 'same-origin',
      })
      localStorage.removeItem('firstLogin')
      signOut()

      window.location.href = process.env.REACT_APP_DEJAVOOEXTRA || '/sign-in'
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    const firstLogin = userAuthData()?.firstLogin;
    const firstLoginLocalStorage = localStorage.getItem('firstLogin')

    if (firstLogin === false && firstLoginLocalStorage === null) {
      setFirstLogin(true)
    }
  }, [userAuthData])

  const closeFirstLogin = async () => {
    await firstLoginMutation()
    setFirstLogin(false)
    setFirstLoginLoading(false)

    localStorage.setItem('firstLogin', 'true')
  }

  return (
    <>
      <Modal show={firstLogin} size="xl">
        <Modal.Header>
          <h4 className='mb-0 mt-2'>
            {intl.formatMessage({ id: 'FIRST_LOGIN.TITLE' })}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <iframe
            title='First Login'
            width='100%'
            height='500px'
            src='https://www.youtube.com/embed/8ZhFB6ImddU?si=EUNk7oTvLFsoFPQN'
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            referrerPolicy='strict-origin-when-cross-origin'
            allowFullScreen
          ></iframe>
        </Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => {
              setFirstLoginLoading(true)
              closeFirstLogin()
            }}
            disabled={firstLoginLoading}
          >
            {firstLoginLoading ? intl.formatMessage({ id: 'LOADING' }) : intl.formatMessage({ id: 'FIRST_LOGIN.CLOSE' })}
          </button>
        </Modal.Footer>
      </Modal>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
        data-kt-menu='true'
      >
        <div className='menu-item px-3'>
          <div className='menu-content d-flex align-items-center px-3'>
            <h3 className='menu-title text-truncate text-dark mb-0 fs-5'>
              {/* {userAuthData()?.fullName} */}
              {intl.formatMessage({ id: 'MY_PROFILE' })}
            </h3>
            {/* <span className='badge badge-dark fw-bolder fs-8 px-2 py-1 ms-2'>Store 1</span> */}
          </div>
        </div>

        <div className='separator my-2'></div>

        <div className='menu-item px-5'>
          <a href='/change-password' className='menu-link px-5'>
            <span className='menu-text'>{intl.formatMessage({ id: 'CHANGE_PASSWORD' })}</span>
            <span className='menu-badge'>
              {/* <span className='badge badge-light-success badge-circle fw-bolder fs-7'>1</span> */}
            </span>
          </a>
        </div>

        <div className='menu-item px-5'>
          <a href='/stores' className='menu-link px-5'>
            <span className='menu-text'>{intl.formatMessage({ id: 'STORE_PLURAL' })}</span>
            <span className='menu-badge'>
              {/* <span className='badge badge-light-success badge-circle fw-bolder fs-7'>1</span> */}
            </span>
          </a>
        </div>

        <div className='menu-item px-5'>
          <a href='#' className='menu-link px-5'>
            {intl.formatMessage({ id: 'UPGRADE_PLAN' })}
          </a>
        </div>

        <div className='menu-item px-5'>
          <a href='/task-in-progress' className='menu-link px-5'>
            {intl.formatMessage({ id: 'TASK_IN_PROGRESS' })}
            {/* <span className='badge badge-square badge-primary ms-2'>5</span> */}
          </a>
        </div>

        <div className='menu-item px-5'>
          <a href='/import-tasks' className='menu-link px-5'>
            {intl.formatMessage({ id: 'IMPORT_TASKS' })}
            {/* <span className='badge badge-square badge-primary ms-2'>5</span> */}
          </a>
        </div>

        <div className='separator my-2'></div>

        <Languages />

        <div className='menu-item px-5 my-1'>
          <a
            onClick={() => {
              logoutRequest()
            }}
            href='#'
            className='menu-link px-5'
          >
            {intl.formatMessage({ id: 'LOGOUT' })}
          </a>
        </div>
      </div>
    </>
  )
}

export { HeaderUserMenu }
